import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointments, resetUpcomingAppointments } from "../redux/actions/appointmentActions";
import {  UpcomingAppointmentHeader, RescheduleModal,AppointmentCancellationModal,AppointmentFilter,UpcomingCard,} from 'tutorapp-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularProgress from '@mui/material/CircularProgress';
import { apiService } from "../utils/apiRequest";
import { toast, ToastContainer } from 'react-toastify';
import { Modal, Button } from "react-bootstrap";
import { resetFamilyAppointmentState } from '../redux/actions/familyAppointmentActions';
import { resetSchoolAppointmentState } from '../redux/actions/schoolAppointmentActions';
import { setAppointmentType } from "../redux/actions/familyPresetValuesActions";
import { BLACK_COLOR } from '../utils/theme';
import { setUserPreferences } from "../redux/actions/userPreferencesActions";
import { setsessionid } from '../redux/actions/sessionActions';


export default function UpcomingAppointmentScreen() {

    const moment = require('moment-timezone');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [date, setDate] = useState(null);
  const [appointmentModaldData, setAppointmentModalData] = useState(false);
  const [appointmentId, setAppointmentId] = useState(null);
  const [sessionType, setSessionType] = useState(null);
  const [joblist, setJoblist] = useState();
  const [subjectlist, setSubjectlist] = useState();
  const [studentlist, setStudentlist] = useState();
  const [sessionsList, setSessionsList] = useState([]);
  const [sessionstatus, Setsessionstatus] = useState('all');
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const { appointments, appointmentloading, error } = useSelector((state) => state.appointments);
  const userPreferences = useSelector((state) => state.userPreferences);
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const showschool = selectedFranchise.country == 'UK'


  const imagePaths = {
    calender: './images/ic_calender.svg',
    time: './images/ic_time.svg',
    down: './images/ic_down.svg',
  };
 

    // Function to calculate duration in minutes
  const calculateDuration = (startDateTime, endDateTime) => {
    if (!startDateTime || !endDateTime) return 0;

    // Parse start and end times using moment
    const start = moment(startDateTime, 'YYYY-MM-DD HH:mm:ss');
    const end = moment(endDateTime, 'YYYY-MM-DD HH:mm:ss');

    // Calculate duration in minutes
    return end.diff(start, 'minutes');
  };

 const convertTimeFormat = (timeString, targetTimezone) => {
  if (!timeString) return '';

  // Validate timeString format (HH:MM:SS)
  const match = timeString.match(/^(\d{2}:\d{2}:\d{2})$/);
  if (!match) return timeString; // Return original string if format doesn't match

  // Parse the time string as UTC and convert to target timezone
  const utcTime = moment.utc(timeString, 'HH:mm:ss');
  if (!moment.tz.zone(targetTimezone)) return timeString; // Return original if invalid timezone

  const convertedTime = utcTime.tz(targetTimezone).format('HH:mm');

  return convertedTime; // Return time in HH:MM format in the target timezone
};

  function extractTime(datetimeString) {
    let match = datetimeString.match(/\d{4}-\d{2}-\d{2} (\d{2}):(\d{2}):(\d{2})/);

    if (match) {
      return `${match[1]}:${match[2]}:${match[3]}`;
    }

    return null; // Return null if no time found
  }

  const parseDateString = (dateStr) => {
    if (!dateStr) return null;

    const [datePart, timePart] = dateStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    // Create a UTC date object (month is 0-based in JavaScript Date)
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  };

  useEffect(() => {
    setAppointmentsList([]);
    dispatch(resetUpcomingAppointments());
  }, []);

  // Add getStudentsBySubject function
  const getStudentsBySubject = (subjectName, data) => {
    if (!data?.students) return [];
    const students = data.students;
    return students.filter(student => student.subject === subjectName);
  };

  const filters = useMemo(() => {
    const baseFilters = {
      AppointmentType: showschool ? ['All', 'Families', 'Schools'] : ['All', 'Families'],
      SessionType: ['All', 'Online', 'In Person'],
      Subject: subjectlist,
      students: []
    };

    if (showschool) {
      baseFilters.JobName = joblist;
    }

    if (studentlist && typeof studentlist === 'object') {
      const studentArray = Object.values(studentlist);

      const selectedSubject = selectedFilters.find(f => f.section === "Subject")?.value[0]?.name;
      if (selectedSubject) {
        baseFilters.students = getStudentsBySubject(selectedSubject, { students: studentArray });
      } else {
        baseFilters.students = studentArray.map(student => ({
          id: student.id,
          name: student.name,
          subject: student.subject
        }));
      }
    }

    return baseFilters;
  }, [joblist, subjectlist, studentlist, selectedFilters, showschool]);

  const filterSections = useMemo(() => {
    const baseSections = [
      { key: 'AppointmentType', label: 'Appointment Type' },
      { key: 'SessionType', label: 'Session Type' },
      { key: 'Subject', label: 'Subject' },
      { key: 'students', label: 'Students' },
    ];

    if (showschool) {
      baseSections.splice(1, 0, { key: 'JobName', label: 'Job Name' }); // Insert JobName after AppointmentType
    }

    return baseSections;
  }, [showschool]);


  const loadMoreAppointments = (selected_date = date, filters = selectedFilters) => {
    const filterdata = transformData(filters);
    dispatch(fetchAppointments(selectedFranchise, page, selected_date, filterdata))
      .then(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching appointments:", err);
        setHasMore(false);
      });
  };

  function transformData(data) {
    const result = {
      appointment_type: null,
      session_type: null,
      student_id: [],
      job_id: [],
      subject_id: []
    };

    data.forEach(item => {
      const section = item.section;
      const values = item.value;

      switch (section) {
        case "AppointmentType":
          if (values === "All") result.appointment_type = '';
          else if (values === "Families") result.appointment_type = 0;
          else if (values === "Schools") result.appointment_type = 1;
          else result.appointment_type = '';
          break;
        case "SessionType":
          if (values === "All") result.session_type = '';
          else if (values === "In Person") result.session_type = 'InPerson';
          else if (values === "Online") result.session_type = 'Online';
          else result.session_type = '';
          break;
        case "JobName":
          result.job_id = values.map(v => v.id);
          break;
        case "Subject":
          result.subject_id = values.map(v => v.id);
          break;
        case "students":
          result.student_id = values.map(v => v.id);
          break;
      }
    });

    return result;
  }

  useEffect(() => {
    if (appointments.status === "success" && appointments.appointments?.length > 0) {
      const newAppointments = appointments.appointments || [];
      setAppointmentsList((prev) => {
        const existingIds = new Set(prev.map((appt) => appt.appointment_id));
        const filteredNewAppointments = newAppointments.filter((appt) => !existingIds.has(appt.appointment_id));
        return [...prev, ...filteredNewAppointments];
      });
      if (newAppointments.length < 25 || newAppointments.length === 0) {
        setHasMore(false);
      }
      if (isInitialFetch) {
        setIsInitialFetch(false);
      }
    } else if (appointments.status === "fail") {
      setHasMore(false);
    }
  }, [appointments.appointments, appointments.status]);

  useEffect(() => {
    const currentDate = new Date();
    const formattedCurrentDate = formatDateToApiString({ startValue: currentDate });
    setDate(formattedCurrentDate);
    setAppointmentsList([]);
    loadMoreAppointments(formattedCurrentDate, selectedFilters);
  }, [dispatch, selectedFranchise]);

  const handleSelectFilter = (newFilters) => {
    setSelectedFilters(newFilters);
    // Reset pagination and appointments list
    setAppointmentsList([]);
    setPage(1);
    setHasMore(true);
    // Trigger API call with new filters
    const filterdata = transformData(newFilters);
    setIsLoading(true);
    dispatch(fetchAppointments(selectedFranchise, 1, date, filterdata))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.error("Error fetching appointments:", err);
        setHasMore(false);
        setIsLoading(false);
      });
  };
  const handleClearAll = () => {
    setSelectedFilters([]);
    setAppointmentsList([]);
    setPage(1);
    setHasMore(true);
    loadMoreAppointments(date, []);
  };

  const handleFilter = async () => {
    setFilterModalVisible(!filterModalVisible);
    if (!filterModalVisible) { // Only fetch data when opening the modal
      setIsLoading(true); // Set loading to true before starting API calls
      try {
        // Run all API calls concurrently and wait for all to complete
        await Promise.all([
          getjoblisting(selectedFranchise),
          getsubjectlisting(selectedFranchise),
          getstudentlisting(selectedFranchise),
        ]);
      } catch (error) {
        console.error("Error fetching filter data:", error);
      } finally {
        setIsLoading(false); // Set loading to false only after all calls complete
      }
    }
  };

  const applyFilters = () => {
    setFilterModalVisible(false); // Close modal only here
  };
  const handleReschedule = (appointmentid, sessiontype) => {
    setAppointmentId(appointmentid);
    setSessionType(sessiontype);
    setRescheduleModalVisible(true);
  };

  function handleSaveChanges(appointmentModalData) {
    const action = 'cancel';
    cancelAppointment(appointmentModalData?.appointment_id, action);
  }

  const handleCancel = (appointment) => {
    setAppointmentId(appointment);
    if (appointment.appointment_for === 'Families') {
      setAppointmentModalData(true);
      setCancelModalVisible(true);
    } else {
      setAppointmentModalData(false)
      setCancelModalVisible(true);
    }
  };

  const handleConfirm = (action) => {
    cancelAppointment(appointmentId, action);
  };

  const handleBack = () => {
    navigate("/Myappointment");
  };
     const  handleAppointmentView = (data) => {
       
          dispatch(setsessionid( data))
    dispatch(setUserPreferences(appointments?.userPreferences))
navigate("/editappointment", { state: { appointment_id: data.appointment_id } });    
};
  const onBottomRightButtonPress = () => {
    dispatch(resetFamilyAppointmentState())
    dispatch(resetSchoolAppointmentState())
    //  navigate('/SelectAppointmentType')
    if (!showschool) {
      dispatch(setAppointmentType({ appointment_type: 0 }));
      navigate("/filldetails");
    } else {
      navigate("/SelectAppointmentType");
    }

  }

  const formatDateToApiString = (dateObj) => {
    // Check if the input is a Date object directly
    const date = dateObj instanceof Date ? dateObj : new Date(dateObj?.startValue);

    // If the date is invalid, return null
    if (isNaN(date)) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };


  const formatTime = (time) => {
    return time ? `${time}:00` : "";
  };

  const handleChange = (d) => {

    setAppointmentsList([]);
    setPage(1);
    setHasMore(true);
    setIsInitialFetch(true);
    const formattedDate = formatDateToApiString(d);
    setDate(formattedDate);
    loadMoreAppointments(formattedDate, selectedFilters);
  };

  const cancelAppointment = async (appointmentId, action) => {
    try {
      setIsLoading(true);
      const cancelappointment = process.env.REACT_APP_API_URL + 'getCancelAppointment';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId?.appointment_id, action }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
                setCancelModalVisible(false);

        setAppointmentsList([]);
        setPage(1);
        setHasMore(true);
        loadMoreAppointments(date);
        setCancelModalVisible(false);
        setIsLoading(false);
        setShow(false);
        toast.success(response.message, {
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" }
        });
      } else {
        console.error("Failed to cancel appointment:", response.message);
        setCancelModalVisible(false);
        setShow(false);
        toast.error(response.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
      }
    } catch (error) {
      console.error("Error while cancelling appointment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const AppointmentReschedule = async (appointmentId, updatedAppointment) => {
    try {
      setIsLoading(true);
      const rescheduleappointment = process.env.REACT_APP_API_URL + 'rescheduleAppointment';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId, updated_appointment: updatedAppointment }),
      };
      const response = await apiService(rescheduleappointment, options);
      if (response.status === 'success') {
        setAppointmentsList([]);
        setPage(1);
        setHasMore(true);
        loadMoreAppointments();
        setRescheduleModalVisible(false);
        setIsLoading(false);
        toast.success(response.message, {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" }
        });
      } else {
        console.error("Failed to reschedule appointment:", response.message);
        setRescheduleModalVisible(false);
        toast.error(response.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
      }
    } catch (error) {
      console.error("Error while rescheduling appointment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onSavehandle = (date, startTime, duration, endTime) => {
    const formattedData = {
      updated_appointment: {
        appointment_date: formatDateToApiString({ startValue: date }),
        start_time: formatTime(startTime),
        end_time: formatTime(endTime),
        session_type: sessionType,
      },
    };
    AppointmentReschedule(appointmentId.appointment_id, formattedData.updated_appointment);
  };

  const getjoblisting = async (selectedFranchise) => {
    try {

      // setIsLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllJob';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        setJoblist(response.job);
      } else {
        console.error("Failed to fetch jobs:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching jobs:", error);
    }
    finally {
      // setIsLoading(false)
    }
  };

  const getsubjectlisting = async (selectedFranchise) => {

    try {
      // setIsLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllSubject';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        setSubjectlist([...response.schools_subject, ...response.families_subject]);
      } else {
        console.error("Failed to fetch subjects:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching subjects:", error);
    } finally {
      // setIsLoading(false)
    }
  };

  const getstudentlisting = async (selectedFranchise) => {
    try {
      // setIsLoading(true)
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllStudent';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: selectedFranchise.franchise_id, tutor_id: selectedFranchise.tutor_id }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        const mergedStudents = [
          ...Object.values(response.schools_student || {}),
          ...Object.values(response.families_student || {})
        ];
        setStudentlist(mergedStudents);
      } else {
        console.error("Failed to fetch students:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching students:", error);
    }

  };

  return (
    <>
      <div>

        {(isLoading || appointmentloading) && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
          >
            <CircularProgress
              size={40}
              sx={{ color: 'black' }}
              aria-label="Loading"
            />
          </div>
        )}

        <div className="sticky-header bg-white shadow-sm">
          <UpcomingAppointmentHeader
            icons={{
              leftarrow: "./images/left.svg",
              filter: "./images/Filter.svg",
              calender: './images/ic_calendar.svg',
              view: "./images/view.svg",
              reschedule: "./images/Add.svg",
              cancel: "./images/Cancel.svg",
              optionsmenu: "./images/ic_options.svg",

            }}
            handleFilter={handleFilter}
            handleChange={handleChange}
            handleBack={handleBack}
            selecteddate={date}
          />
        </div>

        <AppointmentFilter
          isVisible={filterModalVisible}
          onClose={applyFilters}
          filters={filters}
          selectedFilters={selectedFilters}
          onSelectFilter={handleSelectFilter}
          onClearAll={handleClearAll}
          filterSections={filterSections}
          students={filters.students}
          showschool={showschool}
          isloading={isLoading}
          icons={{
            close: "./images/ic_close2.svg",
            chevronup: "./images/dropdown.svg",
            chevrondown: "./images/dropdown_close.svg",
            closeoption: "./images/filter_close.svg",
            studentsearch: "./images/Search.svg"
          }}
        />

        <div>

          {
  appointmentloading ? (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'white', // optional: backdrop
      }}
    >
      <CircularProgress size={40} style={{ color: 'black' }} />
    </div>
  ) : appointmentsList.length < 1 ? (
   <div className="text-center mt-5 p-2" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
  <div style={{ fontFamily: 'GT-Walsheim', fontSize: '16px' }}>
    {appointments?.message || 'No upcoming appointments found'}
  </div>
  <button
    onClick={onBottomRightButtonPress}
    style={{
      marginTop: '16px',
      padding: '10px 40px',
      backgroundColor: BLACK_COLOR, // Ensure BLACK_COLOR is defined, e.g., '#000'
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontFamily: 'GT-Walsheim',
      fontSize: '14px',
      display: 'flex', // Use flexbox for icon and text alignment
      alignItems: 'center', // Vertically center icon and text
      gap: '8px', // Consistent spacing between icon and text
    }}
  >
    <img
      src="./images/Add.svg"
      alt="Add Appointment"
      style={{ width: '32px', height: '32px', verticalAlign: 'middle' }} // Explicit icon size
    />
    Add Appointment
  </button>
</div>
  ) : (
    <InfiniteScroll
      dataLength={appointmentsList.length}
      next={() => loadMoreAppointments(date, selectedFilters)}
      hasMore={hasMore}
      loader={
        appointmentsList.length > 0 && (
          <div className="text-center my-3">
            <CircularProgress size={30} style={{ color: "black" }} />
          </div>
        )
      }
      style={{ overflow: "visible" }}
    >
      <div className="mt-4" style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        {appointmentsList.map((item, index) => (
          <UpcomingCard
            key={item.appointment_id}
            index={index}
            onViewPress={handleAppointmentView}
            onReschedulePress={handleReschedule}
            onCancelPress={handleCancel}
            item={item}
            userPreferences={userPreferences}
            onBottomRightButtonPress={onBottomRightButtonPress}
            isLast={index === 0}
            icons={{
              leftarrow: "./images/left.svg",
              filter: "./images/Filter.svg",
              calender: "./images/ic_calendar.svg",
              view: "./images/view.svg",
              reschedule: "./images/Add.svg",
              cancel: "./images/Cancel.svg",
              optionsmenu: "./images/ic_options.svg",
              placeholderIcon: "./images/Rectangle.svg",
              addbtn: './images/Add.svg',
              close: "./images/ic_close2.svg",
            }}
          />
        ))}
      </div>
    </InfiniteScroll>
  )
}

        </div>

        <AppointmentCancellationModal
                    appointmentfor ={appointmentModaldData}

          visible={cancelModalVisible}
          onClose={() => setCancelModalVisible(false)}
          onConfirm={handleConfirm}
        />

        {appointmentId && appointmentId.start_date_time && (<RescheduleModal

          defaultdate={parseDateString(appointmentId.start_date_time)}
          defaultStartTime={convertTimeFormat(extractTime(appointmentId.start_date_time), userPreferences?.timezone)}
          defaultEndTime={convertTimeFormat(extractTime(appointmentId.end_date_time, userPreferences?.timezone))}
          duration={calculateDuration(appointmentId.start_date_time, appointmentId.end_date_time)}
          userPreferences={userPreferences}
          imagePaths={imagePaths}
          onClose={() => setRescheduleModalVisible(false)}
          visible={rescheduleModalVisible}
          onSave={onSavehandle}
        />)}
      </div>

      <ToastContainer />
    </>
  );
}